export const showError = (_this, error) => {
	let v = '';
	let msj = `errors.${error.code}`;

	if (_this.$t(msj)) {
		v = _this.$t(msj)
	} else {
		v = _this.$t("errors.401")
	}

	_this.$toast.error(_this.$t(v));
}

